
const environment = "STAGING";

const localDevelopment = false;
const Debug = localDevelopment;
const Domain = environment;
const Google_Map_Key = "AIzaSyBGeidlKq2m6aN6f2-X5NYtQlisL-GeZHo";

export { Domain, Debug, environment, Google_Map_Key };

